import React, { Component } from 'react';

class MImg extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: this.props.src,
      className: this.props.className,
    }
  }

  handleError() {
    this.setState({
      src: '/h5/img/wait.gif',
      className: this.state.className + ' error',
    });
  }

  handleClick() {
    this.props.onClick && this.props.onClick(this.state.src);
  }

  render() {
    const { src, className } = this.state;
    return <img
      className={ className }
      src={ src }
      alt="MIB"
      onError={() => this.handleError() }
      onClick={()=> this.handleClick() }
    />
  }
}

export default MImg